// extracted by mini-css-extract-plugin
export default {"backButton":"JKDAPr","input":"QCDchW"};